// Generated from api/openapi/admin.yaml by make docs. Do not edit.
import { z } from "zod";

export const groupRemovalSchema = z.object({
  "member_name": z.string().optional(),
  "id": z.string().uuid(),
  "group_id": z.string().uuid(),
  "group_name": z.string(),
  "target_group_id": z.string(),
  "target_member_id": z.string(),
  "kind": z.enum(["membership_remove", "membership_reconcile", "untracked_adoption"]),
  "state": z.enum(["open", "verified", "withdrawn", "handed_back"]),
  "opened_at": z.string().datetime({ offset: true }),
  "deadline_at": z.string().datetime({ offset: true }),
  "attempts": z.number().int().min(0),
  "last_attempt_at": z.string().datetime({ offset: true }).nullable(),
  "last_error": z.string().nullable(),
  "closed_at": z.string().datetime({ offset: true }).nullable(),
  "handed_back_name": z.string().nullable(),
  "handback_reason": z.string().nullable()
}).strict();

export const groupRemovalsSchema = z.object({
  "items": z.array(groupRemovalSchema),
  "next_cursor": z.string().uuid().nullable()
}).strict();
